import { useModel as _useModel, defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, Transition as _Transition, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = {
    class: "phrase-select-container",
    style: { "--js-phrase-options-group-height": "auto" }
};
var _hoisted_2 = { class: "phrase-select-comlumn" };
var _hoisted_3 = { key: 0 };
var _hoisted_4 = {
    key: 0,
    class: "phrase-modal-options-container"
};
var _hoisted_5 = { class: "phrase-options-aria" };
var _hoisted_6 = { class: "phrase-generate-preview" };
var _hoisted_7 = {
    key: 1,
    class: "phrase-modal-options-container phrase-options-title"
};
var _hoisted_8 = {
    key: 1,
    class: "dynamic-phrase-info"
};
var _hoisted_9 = { class: "dynamic-phrase-info-desc" };
var _hoisted_10 = { class: "create-phrase-container" };
var _hoisted_11 = { class: "create-phrase-column" };
var _hoisted_12 = { class: "create-phrase-column" };
var _hoisted_13 = { class: "create-phrase-column multiple-inputs" };
var _hoisted_14 = { class: "modal-footer" };
var _hoisted_15 = { class: "modal-footer" };
import { ref, watch, computed, h } from "vue";
import { phraseList, dynamicPhrase, generatePhraseToContent, phraseTypes, countParams, addPhrase, } from "@/utils/phrase";
import CustomSVG from "@/components/custom/CustomSVG.vue";
import { NButton, NIcon } from "naive-ui";
import api from "@/utils/api";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PhraseSelectModal',
    props: {
        "isShowModal": {
            type: Boolean,
            required: true,
        },
        "isShowModalModifiers": {},
        "selectedPhraseType": {
            type: String,
            required: true,
        },
        "selectedPhraseTypeModifiers": {},
        "selectedPhrase": {
            type: [String, null],
            required: true,
        },
        "selectedPhraseModifiers": {},
        "onConfirmSelect": {
            type: Function,
            required: true,
        },
        "onConfirmSelectModifiers": {},
    },
    emits: ["update:isShowModal", "update:selectedPhraseType", "update:selectedPhrase", "update:onConfirmSelect"],
    setup: function (__props) {
        var isShowModal = _useModel(__props, "isShowModal");
        var selectedPhraseType = _useModel(__props, "selectedPhraseType");
        var selectedPhraseName = _useModel(__props, "selectedPhrase");
        var onConfirmSelect = _useModel(__props, "onConfirmSelect");
        var newPhraseInput = ref(""), isShowCreatePhraseModal = ref(false), newPhraseName = ref(""), newPhraseDesc = ref(""), newPhraseContent = ref("");
        var phraseValues = ref([]);
        var phraseNameMap = computed(function () {
            return phraseList.value.map(function (item) {
                return {
                    label: item.name,
                    value: item.name,
                };
            });
        });
        var dynamicPhraseMap = computed(function () {
            return dynamicPhrase.map(function (item) {
                return {
                    label: item.name,
                    value: item.name,
                };
            });
        });
        var phraseOptionsComputed = computed(function () {
            if (selectedPhraseType.value === "static") {
                selectedPhraseName.value = null;
                return phraseNameMap.value;
            }
            else if (selectedPhraseType.value === "dynamic") {
                selectedPhraseName.value = dynamicPhrase[0].name;
                return dynamicPhraseMap.value;
            }
            return [];
        });
        watch(selectedPhraseName, function (newValue) {
            if (newValue === "") {
                return;
            }
            if (selectedPhraseType.value === "dynamic") {
                return;
            }
            var selectedPhrase = phraseList.value.find(function (item) { return item.name === newValue; });
            if (selectedPhrase) {
                phraseValues.value = new Array(countParams(selectedPhrase.content)).fill("");
            }
        });
        watch(isShowModal, function (newValue) {
            if (phraseValues.value.length > 0) {
                phraseValues.value.forEach(function (item, index) {
                    phraseValues.value[index] = "";
                });
            }
        });
        var handleFinishCreatePhrase = function () {
            if (newPhraseName.value.trim() === "" || newPhraseDesc.value.trim() === "") {
                window.$notifyError("相关信息缺失", "短语の名前は？");
                return;
            }
            if (newPhraseContent.value.trim() === "") {
                window.$notifyError("内容缺失", "短语内容还没填哦");
                return;
            }
            var count = countParams(newPhraseContent.value);
            if (count > 9) {
                window.$notifyError("占位符过多", "短语内容占位符不能超过9个，太多了啦...");
                return;
            }
            if (count === 0) {
                window.$notifyWarning("创建短语的意义是？", "虽然创建了，但占位符的数量是空...空的？确定不需要占位符进行要填写的内容的快捷输入？");
            }
            addPhrase({
                name: newPhraseName.value,
                desc: newPhraseDesc.value,
                content: newPhraseContent.value,
            })
                .then(function (res) {
                window.$msgSuccess("添加成功");
                console.log("添加成功", phraseList.value);
                isShowCreatePhraseModal.value = false;
            })
                .catch(function (err) {
                window.$message.error("添加失败");
            });
        };
        var previewPhraseText = computed(function () {
            var _a;
            return generatePhraseToContent(((_a = phraseList.value.find(function (item) { return item.name === selectedPhraseName.value; })) === null || _a === void 0 ? void 0 : _a.content) || "", phraseValues.value);
        });
        var dynamicPhrasePreviewText = computed(function () {
            var selectedPhrase = dynamicPhrase.find(function (item) { return item.name === selectedPhraseName.value; });
            if (!selectedPhrase) {
                return "动态短语加载异常";
            }
            return ("\u52A8\u6001\u77ED\u8BED ".concat(selectedPhrase.name, " \u5728\u5F53\u524D\u73AF\u5883\u4E0B\u7684\u503C\u4E3A:\n") +
                String(selectedPhrase.valueCode()));
        });
        var addNewPhrase = function () {
            newPhraseName.value = "";
            newPhraseDesc.value = "";
            newPhraseContent.value = "";
            isShowCreatePhraseModal.value = true;
        };
        var setPhraseOptionsHeightToCssVar = function () {
            var optionsContainer = document.querySelector(".phrase-modal-options-container");
            if (optionsContainer) {
                var height = optionsContainer.offsetHeight;
                optionsContainer.style.setProperty("--js-phrase-options-group-height", "".concat(height, "px"));
            }
        };
        var handleConfirm = function () {
            var _a, _b;
            var comformStr = "";
            if (selectedPhraseType.value === "static") {
                if (selectedPhraseName.value === "") {
                    window.$notifyError("短语名称不能为空", "还没选哦");
                    return;
                }
                comformStr = generatePhraseToContent(((_a = phraseList.value.find(function (item) { return item.name === selectedPhraseName.value; })) === null || _a === void 0 ? void 0 : _a.content) || "", phraseValues.value).replaceAll("\\%", "%"); // 将转义的%还原
            }
            else if (selectedPhraseType.value === "dynamic") {
                comformStr = "\uFFE5\uFFE5\\/".concat(String((_b = dynamicPhrase.find(function (item) { return item.name === selectedPhraseName.value; })) === null || _b === void 0 ? void 0 : _b.valName), "\\/\uFFE5\uFFE5");
            }
            onConfirmSelect.value(comformStr);
            isShowModal.value = false;
        };
        var deletePhrase = function (phraseName) {
            // 返回 Promise，确保类型一致
            return api.request
                .quickPost("/deletephrase", {
                name: phraseName,
            })
                .then(function (res) {
                var index = phraseList.value.findIndex(function (item) { return item.name === phraseName; });
                if (index > -1) {
                    phraseList.value.splice(index, 1);
                    window.$message.success("删除成功");
                }
                else {
                    window.$message.error("列表出错");
                }
                if (selectedPhraseName.value === phraseName) {
                    selectedPhraseName.value = null;
                    phraseValues.value = [];
                }
                return res;
            })
                .catch(function (err) {
                var resp = err.response;
                window.$notifyError("删除失败", resp.msg);
                return Promise.reject(err);
            });
        };
        // ---------------------------
        var renderLabel = function (option) {
            return [
                h("div", {
                    class: "select-option-container",
                }, {
                    default: function () { return [
                        h("span", {
                            class: "option-label",
                        }, option.label),
                        h("div", {
                            class: "select-option-btn-group",
                        }, {
                            default: function () { return [
                                h(NButton, {
                                    class: "select-delete-option-btn",
                                    size: "small",
                                    onClick: function (e) {
                                        e.stopPropagation();
                                        deletePhrase(option.value);
                                    },
                                }, {
                                    icon: function () {
                                        return h(NIcon, { size: "1.2rem" }, function () {
                                            return h(CustomSVG, {
                                                icon: "Delete24Filled",
                                                class: "delete-option-icon",
                                            });
                                        });
                                    },
                                }),
                            ]; },
                        }),
                    ]; },
                }),
            ];
        };
        return function (_ctx, _cache) {
            var _component_n_select = _resolveComponent("n-select");
            var _component_n_input = _resolveComponent("n-input");
            var _component_n_card = _resolveComponent("n-card");
            var _component_n_modal = _resolveComponent("n-modal");
            return (_openBlock(), _createBlock(_component_n_modal, {
                show: isShowModal.value,
                "onUpdate:show": _cache[12] || (_cache[12] = function ($event) { return ((isShowModal).value = $event); })
            }, {
                default: _withCtx(function () { return [
                    _createVNode(_component_n_card, {
                        style: { "width": "700px" },
                        title: "快捷输入",
                        bordered: false,
                        size: "huge",
                        role: "dialog",
                        "aria-modal": "true"
                    }, {
                        "header-extra": _withCtx(function () { return [
                            _createVNode(_unref(NIcon), {
                                size: "1.6rem",
                                onClick: _cache[0] || (_cache[0] = function ($event) { return (isShowModal.value = false); })
                            }, {
                                default: _withCtx(function () { return _cache[13] || (_cache[13] = [
                                    _createElementVNode("i", { class: "fa-solid fa-square-xmark fa-close-style" }, null, -1)
                                ]); }),
                                _: 1
                            })
                        ]; }),
                        footer: _withCtx(function () { return [
                            _createElementVNode("div", _hoisted_15, [
                                _createVNode(_unref(NButton), {
                                    onClick: _cache[11] || (_cache[11] = function ($event) { return (isShowModal.value = false); }),
                                    type: "default",
                                    class: "cancel-button"
                                }, {
                                    default: _withCtx(function () { return _cache[19] || (_cache[19] = [
                                        _createTextVNode(" 取消 ")
                                    ]); }),
                                    _: 1
                                }),
                                _createVNode(_unref(NButton), {
                                    onClick: handleConfirm,
                                    type: "primary",
                                    class: "confirm-button"
                                }, {
                                    default: _withCtx(function () { return _cache[20] || (_cache[20] = [
                                        _createTextVNode(" 确定 ")
                                    ]); }),
                                    _: 1
                                })
                            ])
                        ]; }),
                        default: _withCtx(function () {
                            var _a;
                            return [
                                _createElementVNode("div", _hoisted_1, [
                                    _createElementVNode("div", _hoisted_2, [
                                        _createVNode(_component_n_select, {
                                            class: "phrase-select-type",
                                            value: selectedPhraseType.value,
                                            "onUpdate:value": _cache[1] || (_cache[1] = function ($event) { return ((selectedPhraseType).value = $event); }),
                                            options: _unref(phraseTypes),
                                            placeholder: "选择类型"
                                        }, null, 8, ["value", "options"]),
                                        _createVNode(_component_n_select, {
                                            class: "phrase-select-name",
                                            value: selectedPhraseName.value,
                                            "onUpdate:value": _cache[2] || (_cache[2] = function ($event) { return ((selectedPhraseName).value = $event); }),
                                            options: phraseOptionsComputed.value,
                                            placeholder: "选择短语",
                                            "render-label": selectedPhraseType.value === 'static' ? renderLabel : undefined
                                        }, null, 8, ["value", "options", "render-label"]),
                                        _createVNode(_unref(NButton), {
                                            onClick: addNewPhrase,
                                            type: "primary",
                                            class: "add-new-option-button"
                                        }, {
                                            default: _withCtx(function () { return _cache[14] || (_cache[14] = [
                                                _createTextVNode(" 新建短语 ")
                                            ]); }),
                                            _: 1
                                        })
                                    ]),
                                    (selectedPhraseType.value === 'static')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                            _createVNode(_Transition, {
                                                name: "phrase-options-fade",
                                                onBeforeEnter: setPhraseOptionsHeightToCssVar,
                                                onBeforeLeave: setPhraseOptionsHeightToCssVar
                                            }, {
                                                default: _withCtx(function () { return [
                                                    (phraseValues.value.length > 0)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                            _createElementVNode("div", _hoisted_5, [
                                                                _cache[15] || (_cache[15] = _createElementVNode("span", { class: "phrase-options-title" }, "短语参数，可使用\\\"来转义\"符号，如果填入动态变量名则以动态变量解析", -1)),
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(phraseValues.value, function (item, index) {
                                                                    return (_openBlock(), _createBlock(_component_n_input, {
                                                                        value: phraseValues.value[index],
                                                                        "onUpdate:value": function ($event) { return ((phraseValues.value[index]) = $event); },
                                                                        placeholder: "\u8BF7\u8F93\u5165\u53C2\u6570".concat(index + 1),
                                                                        class: "phrase-input"
                                                                    }, null, 8, ["value", "onUpdate:value", "placeholder"]));
                                                                }), 256))
                                                            ]),
                                                            _createElementVNode("div", _hoisted_6, [
                                                                _createVNode(_component_n_input, {
                                                                    value: previewPhraseText.value,
                                                                    "onUpdate:value": _cache[3] || (_cache[3] = function ($event) { return ((previewPhraseText).value = $event); }),
                                                                    class: "phrase-preview-input",
                                                                    type: "textarea",
                                                                    rows: 6,
                                                                    disabled: "",
                                                                    placeholder: "短语内容预览"
                                                                }, null, 8, ["value"])
                                                            ])
                                                        ]))
                                                        : (_openBlock(), _createElementBlock("span", _hoisted_7, "请先选择短语"))
                                                ]; }),
                                                _: 1
                                            })
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                            _createElementVNode("span", _hoisted_9, _toDisplayString(((_a = _unref(dynamicPhrase).find(function (obj) { return obj.name === selectedPhraseName.value; })) === null || _a === void 0 ? void 0 : _a.desc) || "未找到指定名称的动态短语"), 1),
                                            _createVNode(_component_n_input, {
                                                value: dynamicPhrasePreviewText.value,
                                                "onUpdate:value": _cache[4] || (_cache[4] = function ($event) { return ((dynamicPhrasePreviewText).value = $event); }),
                                                class: "phrase-preview-input",
                                                type: "textarea",
                                                rows: 6,
                                                disabled: "",
                                                placeholder: "短语内容预览"
                                            }, null, 8, ["value"])
                                        ]))
                                ]),
                                _createVNode(_component_n_modal, {
                                    show: isShowCreatePhraseModal.value,
                                    "onUpdate:show": _cache[10] || (_cache[10] = function ($event) { return ((isShowCreatePhraseModal).value = $event); })
                                }, {
                                    default: _withCtx(function () { return [
                                        _createVNode(_component_n_card, {
                                            style: { "width": "600px" },
                                            title: "新建快捷输入",
                                            bordered: false,
                                            size: "huge",
                                            role: "dialog",
                                            "aria-modal": "true"
                                        }, {
                                            "header-extra": _withCtx(function () { return [
                                                _createVNode(_unref(NIcon), {
                                                    size: "1.6rem",
                                                    onClick: _cache[5] || (_cache[5] = function ($event) { return (isShowCreatePhraseModal.value = false); })
                                                }, {
                                                    default: _withCtx(function () { return _cache[16] || (_cache[16] = [
                                                        _createElementVNode("i", { class: "fa-solid fa-square-xmark fa-close-style" }, null, -1)
                                                    ]); }),
                                                    _: 1
                                                })
                                            ]; }),
                                            footer: _withCtx(function () { return [
                                                _createElementVNode("div", _hoisted_14, [
                                                    _createVNode(_unref(NButton), {
                                                        onClick: _cache[9] || (_cache[9] = function ($event) { return (isShowCreatePhraseModal.value = false); }),
                                                        type: "default",
                                                        class: "cancel-button"
                                                    }, {
                                                        default: _withCtx(function () { return _cache[17] || (_cache[17] = [
                                                            _createTextVNode(" 取消 ")
                                                        ]); }),
                                                        _: 1
                                                    }),
                                                    _createVNode(_unref(NButton), {
                                                        onClick: handleFinishCreatePhrase,
                                                        type: "primary",
                                                        class: "confirm-button"
                                                    }, {
                                                        default: _withCtx(function () { return _cache[18] || (_cache[18] = [
                                                            _createTextVNode(" 确定 ")
                                                        ]); }),
                                                        _: 1
                                                    })
                                                ])
                                            ]; }),
                                            default: _withCtx(function () { return [
                                                _createElementVNode("div", _hoisted_10, [
                                                    _createElementVNode("div", _hoisted_11, [
                                                        _createVNode(_component_n_input, {
                                                            value: newPhraseName.value,
                                                            "onUpdate:value": _cache[6] || (_cache[6] = function ($event) { return ((newPhraseName).value = $event); }),
                                                            placeholder: "短语名称"
                                                        }, null, 8, ["value"])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_12, [
                                                        _createVNode(_component_n_input, {
                                                            value: newPhraseDesc.value,
                                                            "onUpdate:value": _cache[7] || (_cache[7] = function ($event) { return ((newPhraseDesc).value = $event); }),
                                                            placeholder: "短语描述"
                                                        }, null, 8, ["value"])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_13, [
                                                        _createVNode(_component_n_input, {
                                                            value: newPhraseContent.value,
                                                            "onUpdate:value": _cache[8] || (_cache[8] = function ($event) { return ((newPhraseContent).value = $event); }),
                                                            placeholder: "\u77ED\u8BED\u5185\u5BB9\n\u8BF4\u660E\uFF1A\u5BF9\u4E8E\u5360\u4F4D\u5185\u5BB9\uFF0C\u4F9D\u6B21\u4F7F\u7528%1\u3001%2\u3001%3...\u76F4\u5230%9\u8FDB\u884C\u5360\u4F4D\n\u5360\u4F4D\u7B26\u5728\u9009\u62E9\u8BE5\u77ED\u8BED\u8F93\u5165\u65F6\u4F1A\u9700\u8981\u8FDB\u884C\u53C2\u6570\u66FF\u6362",
                                                            type: "textarea",
                                                            rows: 6
                                                        }, null, 8, ["value"])
                                                    ])
                                                ])
                                            ]; }),
                                            _: 1
                                        })
                                    ]; }),
                                    _: 1
                                }, 8, ["show"])
                            ];
                        }),
                        _: 1
                    })
                ]; }),
                _: 1
            }, 8, ["show"]));
        };
    }
});
